export default function serializeMessage(message) {
  return JSON.stringify(message);
}
